import { Button, Grid, Switch } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer/Drawer';
import InputLabel from '@material-ui/core/InputLabel';
import ProductQuickView from 'components/Shared/ProductQuickView';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import React, { Component } from 'react';
import * as rxjsOperators from 'rxjs-operators';
import { combineLatest } from 'rxjs';
import { configService } from 'services/configService';
import { productNewService } from 'services/productNewService';
import { IConfig } from 'interfaces/config';
import Snackbar from 'components/Shared/Snackbar';
import { analyticsG4, enFeatures } from 'services/AnalyticsG4';

interface IState {
  selectedProduct: IProductNew;
  config: IConfig;
  show: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  '@keyframes toLeft': {
    from: {
      transform: 'translate(448px)'
    },
    to: {
      transform: 'translate(0)'
    }
  },
  drawerPaper: {
    transform: 'translate(448px)',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    fontFamily: 'Lato',
    width: '448px',
    '@media screen and (max-width: 960px)': {
      width: '100%'
    }
  },
  drawerOptions: {
    overflow: 'auto',
    backgroundColor: '#fff',
    height: '100%',
    padding: 20,
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10
    }
  },
  titleClose: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  h2: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: 0
  },
  label: {
    fontWeight: 'bold',
    color: '#596375',
    fontSize: '14px',
    margin: '5px 0'
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },
  button: {
    fontWeight: 400,
    backgroundColor: '#009358',
    color: '#fff',
    width: '100%',
    padding: 10
  },
  containerPhone: {
    marginTop: '16px',
    marginBottom: '27px'
  },
  notificationIcon: {
    fill: '#4CAF50',
    marginLeft: 6
  }
}))
export default class EmailActions extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { selectedProduct: null, config: null, show: false };
  }

  onClose = () => {
    configService.hideDrawer();
  };

  onChangeSwitch = () => {
    const { config } = this.state;
    const { requestEmailConfirmation } = config;

    this.setState(prev => ({
      ...prev,
      config: { ...config, requestEmailConfirmation: !requestEmailConfirmation }
    }));
  };

  componentDidMount() {
    combineLatest([configService.getSelectedProduct(), configService.getProductConfig()])
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(([selectedProduct, config]) => {
        this.setState({
          selectedProduct,
          config
        });
      });

    configService
      .getVisibility()
      .pipe(rxjsOperators.map(drawer => drawer === 'emailConfirmation'))
      .subscribe(show => this.setState({ show }));

    combineLatest([configService.getSelectedProduct(), configService.getProductConfig(), configService.getVisibility()])
      .pipe(
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(([selectedProduct, config, drawer]) => {
          return { selectedProduct, config: !!config, drawer };
        }),
        rxjsOperators.distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        rxjsOperators.filter(
          ({ selectedProduct, config, drawer }) => !!selectedProduct && !!config && drawer === 'emailConfirmation'
        )
      )
      .subscribe(() => {
        analyticsG4.sendPageView({ feature: enFeatures.CONFIRMACAO_EMAIL });
      });
  }

  submitRequestConfirmation = () => {
    const { config, selectedProduct } = this.state;

    configService
      .saveConfig(config)
      .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
      .subscribe(() => {
        analyticsG4.sendSuccess(enFeatures.CONFIRMACAO_EMAIL);
        Snackbar.show('Configuração salva!');
        productNewService.setSelectedProduct({
          ...selectedProduct,
          config
        });
        productNewService.refreshProducts();
      });

    this.onClose();
  };

  render() {
    const { classes } = this.props;

    const { selectedProduct, config, show } = this.state;
    if (!show || (!config && !selectedProduct)) {
      return null;
    }

    return (
      <Drawer
        anchor="right"
        open={!!selectedProduct}
        ModalProps={{
          classes: { root: classes.removeBackdrop },
          disableBackdropClick: true,
          onBackdropClick: this.onClose
        }}
        PaperProps={{ classes: { root: classes.drawerPaper } }}
        transitionDuration={{ enter: 300, exit: 500 }}
      >
        <div className={classes.drawerOptions}>
          <div className={classes.titleClose}>
            <h2 className={classes.h2}>Ativando Confirmação de Email</h2>
            <span className={classes.closeButton} onClick={this.onClose}>
              <SvgIcon name={'closeIcon'} />
            </span>
          </div>
          <ProductQuickView />
          <Grid container spacing={16} alignItems="center" justify="space-between">
            <Grid container direction="row" alignItems="center">
              <InputLabel className={classes.label}>Pedir para confirmar Email</InputLabel>
              <Switch
                onChange={this.onChangeSwitch}
                value={config.requestEmailConfirmation}
                checked={config.requestEmailConfirmation}
                disableRipple
              />
            </Grid>
            <Grid item xs={12}>
              <Button onClick={this.submitRequestConfirmation} className={classes.button}>
                Salvar
              </Button>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    );
  }
}
